export { messages as ar } from './ar/messages';
export { messages as ckb } from './ckb/messages';
export { messages as en } from './en/messages';

export const config: Record<
  'ar' | 'ckb' | 'en',
  {
    dir: 'rtl' | 'ltr';
    name: string;
    code: string;
  }
> = {
  ar: {
    dir: 'rtl',
    name: 'العربية',
    code: 'AR',
  },
  ckb: {
    dir: 'rtl',
    name: 'کوردیی سۆرانی',
    code: 'CKB',
  },
  en: {
    dir: 'ltr',
    name: 'English',
    code: 'EN',
  },
};
